<style scoped>
  div {
    /*border: 1px solid pink;*/
  }

  .low {
    /*color: #739c2b;*/
    color: var(--color-success-light);
  }

  .moderate {
    color: #eeb00f;
  }

  .high {
    /*color: #f02a47;*/
    color:var(--color-danger-light);
  }
</style>
<template>
  <div style="text-align: left;">
    <div>{{ $text.tr('РИСК') }} <Tooltip style="" max-width="300" placement="right-start" :content="$text.tr('Уровень маржи = Общая стоимость активов / (Сумма заимствованных средств + процентная ставка)\n\nЕсли ваш уровень маржи упадет до 1.1, ваша позиция будет автоматически ликвидирована. Это означает, что Binance продаст ваши активы по текущей рыночной цене, чтобы погасить задолженность.')">
      <Icon style="color: var(--color-neutral); vertical-align: top; padding-top: 3px;" size="14" type="ios-information-circle-outline"></Icon>
    </Tooltip></div>
    <div style="height: 26px; font-size: 16px; padding-top: 2px; font-weight: normal" :class="{low: parseFloat(risk) >= 1.5, moderate: parseFloat(risk) >= 1.3 && parseFloat(risk) < 1.5, high: parseFloat(risk) < 1.3}">{{ risk }}</div>
  </div>
</template>

<script>
import terminal from '@/services/terminal'
export default {
  name: 'Risk',
  data () {
    return {
    }
  },
  computed: {
    risk () {
      return this.$store.state.risk.risk
    }
  },
  methods: {
    updateMarginLevel () {
      terminal.GetMarginLevel().then(response => {
        this.$store.state.risk.risk = response.data.MarginLevel
        // console.log('margin level updated: ', this.risk)
      }).catch(function (error) {
        console.log(error)
      })
    }
  },
  mounted () {
    // console.log('risk mounted')
    if (!this.$store.state.risk.riskUpdateInterval) {
      this.updateMarginLevel()
      this.$store.state.risk.riskUpdateInterval = setInterval(this.updateMarginLevel, 60 * 1000)
      // console.log('riskUpdateInterval created')
    }
  },
  destroyed () {
    // console.log('risk destroyed')
    clearInterval(this.$store.state.risk.riskUpdateInterval)
    this.$store.state.risk.riskUpdateInterval = null
    this.$store.state.risk.risk = ''
  }
}
</script>
